import { render, staticRenderFns } from "./FicheUser.vue?vue&type=template&id=f53e5c2c"
import script from "./FicheUser.vue?vue&type=script&lang=ts"
export * from "./FicheUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports